import axios from 'axios'
export default{
   getArticleList(techId,pageIndex,keyWord){
    return axios.get(`/api/articleview2/list/${techId}/${pageIndex}?kw=${keyWord}`);
   }
}